import { usePaginatedQuery } from '@hooks/usePaginatedQuery';
import { useAuth } from '@contexts/AuthContext';
import { GET_PROS } from '@gql/pros';
import { Company } from '../CompanyDataTable';

export interface CompaniesFilter {
    sector?: string[];
    postalCode?: string[];
    city?: string[];
    totalJobOffersMin?: number;
    totalJobOffersMax?: number;
}

interface GetProsResponse {
    getPros: {
        docs: Company[];
        meta: {
            page: number;
            totalPages: number;
            totalDocs: number;
            nextPage: number | null;
            prevPage: number | null;
        };
    };
}

export const useGetCompanies = (
    query: string = '',
    filter: CompaniesFilter = {},
    sortBy: { field: string; order: number } = { field: 'createdDate', order: -1 },
    page: number = 0,
    pageSize: number = 10,
) => {
    const { user } = useAuth();

    const gqlFilter = Object.keys(filter).length > 0 ? filter : undefined;

    const { rows, totalDocs, loading, isLoadingMore, hasMore, loadMore, error, refetch } =
        usePaginatedQuery<Company, GetProsResponse>({
            query: GET_PROS,
            variables: {
                query,
                sortBy: sortBy.field,
                sortOrder: sortBy.order,
                filter: gqlFilter,
            },
            page,
            pageSize,
            baseLimit: 10,
            paginationMode: 'offset',
            skip: !user,
            extractResult: (data) => ({
                docs: data.getPros.docs,
                meta: data.getPros.meta,
                totalDocs: data.getPros.meta.totalDocs,
            }),
        });

    return {
        companies: rows,
        totalDocs,
        loading,
        isLoadingMore,
        hasMore,
        loadMore,
        error,
        refetch,
    };
};
